import * as React from 'react';
import {ChangeEvent} from 'react';
import {Input} from 'antd';
import locales from '../locales';
import './SearchFilter.css';

export interface SearchFilterProps {
  prefixCls: string;
  setSelectedKeys: (selectedKeys: any[]) => void;
  selectedKeys: any[];
  confirm: () => void;
  clearFilters: () => void;
}

interface SearchFilterState {
  searchText: string | null;
}

class SearchFilter extends React.Component<SearchFilterProps, SearchFilterState> {

  private readonly input: React.RefObject<Input>;

  constructor(props: SearchFilterProps) {
    super(props);
    this.input = React.createRef();
  }

  public render() {
    return (
      <div className="ant-table-filter-dropdown">
        <div style={{padding: 4}}>
          <Input
            placeholder={locales.search_term}
            value={this.props.selectedKeys!![0]}
            onChange={this.onFilterChange}
            onPressEnter={this.handleSearch}
            size="small"
            ref={this.input}
          />
        </div>
        <div className="ant-table-filter-dropdown-btns">
          <a className="ant-table-filter-dropdown-link confirm"
             onClick={this.handleSearch}>{locales.search}</a>
          <a className="ant-table-filter-dropdown-link clear" onClick={this.handleReset}>{locales.delete}</a>
        </div>
      </div>
    );
  }

  public focus = () => {
    const input = this.input.current;
    if (input) {
      input.focus();
    }
  };

  private onFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.props.setSelectedKeys(e.target.value ? [e.target.value] : []);
  };

  private handleSearch = () => {
    this.props.confirm();
    this.setState({
      searchText: this.props.selectedKeys[0]
    });
  };

  private handleReset = () => {
    this.props.clearFilters();
    this.setState({
      searchText: null,
    });
  };
}

export default SearchFilter;

export function handleFilterFocus(searchFilter: SearchFilter | null): (visible: boolean) => void {
  return (visible: boolean) => {
    if (visible) {
      setTimeout(() => {
        if (searchFilter) {
          searchFilter.focus();
        }
      }, 250);  // 250ms to avoid filter dialog flickering on Android
    }
  };
}


// WEBPACK FOOTER //
// ./src/common/SearchFilter.tsx